// See https://app.taricsupport.com/#!/classification-regulations/en/search?orderBy=relevance&includeBtis=true&includeClassificationRegulations=true&query=toy&commodityCode=
module.exports = {
    ClassificationRegulations: 'Classification Regulations',
    NotAvailableInChosenLanguage: 'Classification Regulations are only available in English and Dutch'
};